<div class="container" [style]="containerStyle">

  <div *ngIf="isLoadingInModal" class="loading-container" @loadingAnimation>
    <div class="recog-body16 loading-message" *ngIf="loadingMessage">
      <div *ngFor="let message of loadingMessage">
        {{ message }}
      </div>
    </div>
    <app-loading-spinner [backdrop]="false" size="50" class="customSpinner" [smallSize]="true"
      [size]="'30'"></app-loading-spinner>
  </div>


  <div *ngIf="!isLoadingInModal" class="modal-wrapper" [style.gap]="gap" @collapse>
    <div *ngIf="title" class="recog-h4-bold title">{{ title | t }}</div>

    <div *ngIf="message && message.isTop" class="recog-body16 message" [class]="[message.align, message.customClass]">{{
      message.text| t }}
    </div>

    <div *ngIf="dataset?.datas" class="data-container" [class]="dataset.type" [style.padding]="dataset.padding">
      <div class="data" *ngFor="let data of dataset.datas; let i = index">
        <div class="key" [style]="data.style">{{ data.key | t }}<span *ngIf="dataset.hasColon">:&nbsp;</span></div>
        <!-- Conditionally translate the first item if dataset.type is 'table' -->
        <div class="value" [style]="data.style" *ngIf="dataset.type === 'table' && i === 0">
          {{ data.value | t }} <!-- Apply translation pipe -->
        </div>

        <!-- Default rendering for other items -->
        <div class="value" [style]="data.style" *ngIf="!(dataset.type === 'table' && i === 0)">
          {{ data.value }}
        </div>
      </div>
    </div>

    <div *ngIf="message && !message.isTop" class="recog-body16" [class]="[message.align, message.customClass]">{{
      message.text| t }}
    </div>

    <div *ngIf="messageBeforeLogo" class="course-validity-message recog-body13"
      [class]="[messageBeforeLogo.align, messageBeforeLogo.customClass]">
      {{ messageBeforeLogo.text | t }}
    </div>

    <div *ngIf="logo"><img class="multimodal-image" [src]="logo"></div>

    <div *ngIf="checkbox" class="checkbox-row">
      <div class="flexVerticalCenter">
        <ion-checkbox [(ngModel)]="checkboxChecked" (ionChange)="onCheckboxChange($event)" color="recog-lemon"
          class="checkbox">
        </ion-checkbox>
        <ion-label class="recog-body13-bold">
          <ion-label>{{ checkbox.label | t }}</ion-label>
          <ion-label *ngIf="checkbox.link" color="recog-lemon" class="linkStyle" (click)="checkbox.link.handler()">
            {{ checkbox.link.text | t }}
          </ion-label>
        </ion-label>
      </div>
    </div>

    <div class="buttons-container">
      <ion-button [disabled]="buttonClicked || (button.role === 'confirm' && checkbox?.required && !checkboxChecked)"
        [class]="button.class" *ngFor="let button of buttons" (click)="buttonClick(button)">
        <span class="button-text" *ngIf="!button.isLoadingInButton"><ion-icon *ngIf="button.icon"
            [name]="button.icon"></ion-icon>{{
          button.text | t}}</span>
        <app-loading-spinner *ngIf="button.isLoadingInButton" [backdrop]="false" size="50" class="customSpinner"
          [smallSize]="true" [size]="'30'"></app-loading-spinner>
      </ion-button>
    </div>
  </div>
</div>